import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { HowItWorks } from '../components/HowItWorks';
import { Comparison } from '../components/Comparison';
import { FAQ } from '../components/FAQ';
import { Blog } from '../components/Blog';
import { CallToAction } from '../components/CallToAction';
import { motion, useScroll, useSpring } from 'framer-motion';
import { ThemeProvider, useTheme } from '../contexts/ThemeContext';
import { LanguageProvider, useLanguage } from '../contexts/LanguageContext';
import { Sun, Moon, Globe } from 'lucide-react';
function Navigation() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  return <nav className="fixed top-0 w-full bg-white/80 dark:bg-dark-bg/80 backdrop-blur-md z-40 border-b border-gray-100 dark:border-dark-border transition-colors duration-300" data-id="element-264">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <div className="flex justify-between items-center h-16" data-id="element-266">
          <div className="flex items-center gap-2" data-id="element-267">
            <div className="w-8 h-8 bg-accent-blue rounded-lg flex items-center justify-center text-white font-bold" data-id="element-268">
              S
            </div>
            <span className="font-bold text-xl text-gray-900 dark:text-white tracking-tight" data-id="element-269">
              SoftUI
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8" data-id="element-270">
            <a href="#" className="text-gray-600 dark:text-gray-300 hover:text-accent-blue dark:hover:text-white transition-colors text-sm font-medium" data-id="element-271">
              {t.nav.features}
            </a>
            <a href="#" className="text-gray-600 dark:text-gray-300 hover:text-accent-blue dark:hover:text-white transition-colors text-sm font-medium" data-id="element-272">
              {t.nav.howItWorks}
            </a>
            <a href="#" className="text-gray-600 dark:text-gray-300 hover:text-accent-blue dark:hover:text-white transition-colors text-sm font-medium" data-id="element-273">
              {t.nav.comparison}
            </a>
            <a href="#" className="text-gray-600 dark:text-gray-300 hover:text-accent-blue dark:hover:text-white transition-colors text-sm font-medium" data-id="element-274">
              {t.nav.blog}
            </a>

            <div className="flex items-center gap-4 border-l border-gray-200 dark:border-dark-border pl-6" data-id="element-275">
              <button onClick={toggleTheme} className="p-2 text-gray-500 dark:text-gray-400 hover:text-accent-blue dark:hover:text-white transition-colors" data-id="element-276">
                {theme === 'light' ? <Moon className="w-5 h-5" data-id="element-277" /> : <Sun className="w-5 h-5" data-id="element-278" />}
              </button>

              <button onClick={() => setLanguage(language === 'en' ? 'ru' : 'en')} className="flex items-center gap-1 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-accent-blue dark:hover:text-white transition-colors" data-id="element-279">
                <Globe className="w-4 h-4" data-id="element-280" />
                {language.toUpperCase()}
              </button>

              <button className="px-4 py-2 bg-gray-900 dark:bg-white text-white dark:text-black rounded-lg text-sm font-medium hover:bg-gray-800 dark:hover:bg-gray-200 transition-colors" data-id="element-281">
                {t.nav.start}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>;
}
function LandingPageContent() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="min-h-screen bg-white dark:bg-dark-bg selection:bg-accent-light selection:text-accent-blue transition-colors duration-300" data-id="element-282">
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-accent-blue origin-left z-50" style={{
      scaleX
    }} data-id="element-283" />

      <Navigation data-id="element-284" />

      <main data-id="element-285">
        <Hero data-id="element-286" />
        <Features data-id="element-287" />
        <HowItWorks data-id="element-288" />
        <Comparison data-id="element-289" />
        <FAQ data-id="element-290" />
        <Blog data-id="element-291" />
        <CallToAction data-id="element-292" />
      </main>

      <footer className="bg-warm-50 dark:bg-black border-t border-gray-200 dark:border-dark-border py-12 transition-colors duration-300" data-id="element-293">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-294">
          <div className="flex items-center gap-2" data-id="element-295">
            <div className="w-6 h-6 bg-gray-300 dark:bg-gray-700 rounded flex items-center justify-center text-white text-xs font-bold" data-id="element-296">
              S
            </div>
            <span className="font-semibold text-gray-900 dark:text-white" data-id="element-297">
              SoftUI Design System
            </span>
          </div>
          <p className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-298">
            © 2024 SoftUI Inc. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}
export function LandingPage() {
  return <ThemeProvider data-id="element-299">
      <LanguageProvider data-id="element-300">
        <LandingPageContent data-id="element-301" />
      </LanguageProvider>
    </ThemeProvider>;
}